import { parse } from 'query-string-es5'

const ZENDESK_SSO_PATH = 'bff/zendesk/sso'
const ALLOWED_QUERY_KEYS = ['return_to', 'brand_id', 'locale_id', 'timestamp']

/**
 * Only allow the Zendesk SSO resume path as an external redirect target.
 * Blocks open redirects / XSS via javascript:, protocol-relative, or absolute URLs.
 */
export const getAllowedExternalRedirect = redirect => {
  if (!redirect || typeof redirect !== 'string') {
    return null
  }

  if (
    redirect.includes('\\')
    || redirect.includes(':')
    || redirect.startsWith('//')
    || redirect.includes('..')
  ) {
    return null
  }

  const [path, queryString] = redirect.split('?')

  if (path !== ZENDESK_SSO_PATH) {
    return null
  }

  if (!queryString) {
    return ZENDESK_SSO_PATH
  }

  const params = parse(queryString)
  const keys = Object.keys(params)

  if (keys.some(key => !ALLOWED_QUERY_KEYS.includes(key))) {
    return null
  }

  return `${ZENDESK_SSO_PATH}?${queryString}`
}
